import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import tw from 'tailwind.macro';
import { GALLERY_IMAGES } from './constants';

const Container = styled.div`
  ${tw`flex overflow-hidden`}
  gap:var(--size-huge);
  flex-wrap: nowrap;
`;

const Image = styled.img`
  ${tw`w-full`}
  max-width: 100%;
  object-fit: contain;
  @media (min-width: 768px) {
    ${tw`w-auto`}
    height:400px;
  }
`;

const Gallery = () => (
  <Container>
    <Swiper slidesPerView={1.5} spaceBetween={50}>
      {GALLERY_IMAGES.map((image, index) => (
        <SwiperSlide key={index}>
          <Image
            alt={image.altMessage}
            src={image.src}
            srcSet={`
            ${image.src} 1x,
            ${image.src2x} 2x,
            ${image.src3x} 3x
          `}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  </Container>
);

export default Gallery;
